export default __webpack_public_path__ + "static/media/logo-sm.0640b323.svg";